import type { ColorMode, ThemeName } from '../../platform/user-preferences/themes';
import type { Locale } from '../../platform/user-preferences/locales';
import type { MyBlogDto } from '../workspaces/dto';
import type { PageQuery } from '../../paging';

export enum PlatformRole {
  Admin = 'admin',
  User = 'user',
}

export interface UserDto {
  id: string;
  login: string;
  displayName: string;
  platformRole: PlatformRole;
  disabled: boolean;
  createdAt: string;
  /** IAM-UC-6.CC-3: последняя активность (вход, открытие или закрытие приложения); null — не появлялся. */
  lastSeenAt: string | null;
}

export interface UserPreferencesDto {
  locale: Locale;
  theme: ThemeName;
  colorMode: ColorMode;
  lastBlogId: string | null;
}

// IAM-UC-3
export interface MeDto {
  user: UserDto;
  preferences: UserPreferencesDto;
  blogs: MyBlogDto[];
}

// IAM-UC-1
export interface LoginRequestDto {
  login: string;
  password: string;
}

export interface LoginResponseDto {
  token: string;
  expiresAt: string;
}

// IAM-UC-14: регистрация отвечает тем же, что и вход.
export interface RegisterRequestDto {
  login: string;
  displayName: string;
  password: string;
}

// IAM-UC-4
export interface ChangePasswordRequestDto {
  currentPassword: string;
  newPassword: string;
}

export type UpdatePreferencesRequestDto = Partial<UserPreferencesDto>;

// IAM-UC-5
export interface CreateUserRequestDto {
  login: string;
  displayName: string;
  password: string;
  platformRole: PlatformRole;
}

// IAM-UC-6, IAM-UC-6.CC-2: поиск по логину и имени; без limit — все пользователи.
export interface UserListQuery extends PageQuery {
  q?: string;
}

// IAM-UC-6
export interface UpdateUserRequestDto {
  displayName?: string;
  platformRole?: PlatformRole;
  disabled?: boolean;
}

// IAM-UC-7
export interface ResetPasswordRequestDto {
  password: string;
}
